import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const FAQ = () => {
  const { t } = useLanguage();
  return (
    <section id="faq" data-testid="faq-section" className="py-20 md:py-32 bg-white">
      <div className="max-w-4xl mx-auto px-5 md:px-10">
        <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#0055FF]">
          {t.faq.kicker}
        </div>
        <h2 className="mt-3 font-heading text-3xl md:text-5xl font-bold tracking-tight text-neutral-900">
          {t.faq.title}
        </h2>
        {t.faq.intro && (
          <p
            data-testid="faq-intro"
            className="mt-4 text-lg text-neutral-600 leading-relaxed max-w-2xl"
          >
            {t.faq.intro}
          </p>
        )}

        <Accordion
          type="single"
          collapsible
          className="mt-10 md:mt-14 divide-y divide-slate-200"
        >
          {t.faq.items.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-slate-200 border-t-0"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="py-5 text-left text-base md:text-lg font-semibold text-neutral-900 hover:text-[#0055FF] hover:no-underline"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${i}`}
                className="pb-5 text-neutral-600 text-base leading-relaxed"
              >
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div
          data-testid="faq-still-cta"
          className="mt-12 md:mt-16 rounded-3xl bg-[#F8FAFC] border border-slate-200 p-8 md:p-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-5"
        >
          <div>
            <h3 className="font-heading text-xl md:text-2xl font-semibold text-neutral-900">
              {t.faq.stillHave}
            </h3>
          </div>
          <a
            href="#contact"
            data-testid="faq-cta-button"
            className="group inline-flex items-center gap-2 rounded-full bg-[#0055FF] text-white px-6 py-3.5 text-sm md:text-base font-semibold hover:bg-[#0044dd] transition-all shadow-lg shadow-[#0055FF]/20 whitespace-nowrap"
          >
            {t.faq.cta}
            <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
